import React from "react";
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { toolbarHeight } from "./ApplicationBar";
import { NavLink, useRouteMatch } from "react-router-dom";
import ProfileMenu from "../../../Controllers/UserMenu";

export const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    whiteSpace: "nowrap",
    position: "relative",
    width: drawerWidth,
    marginTop: toolbarHeight,
    marginBottom: toolbarHeight,
    maxHeight: `calc(100vh - ${toolbarHeight * 2}px)`,

    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  navContainer: {
    paddingLeft: theme.spacing(2),
    maxHeight: `calc(100vh - ${toolbarHeight * 2 + 100}px)`,
    overflow: "auto",
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
  },
  navHeader: {
    fontWeight: 600,
    fontSize: 16,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  CloseNavHeader: {
    fontWeight: 900,
    fontSize: 20,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2.1),
    textAlign: "center",
    marginLeft: -6,
  },
  profileMenu: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  navItem: {
    minWidth: 40,
  },
  activeNav: {
    color: theme.palette.gif.blue.color,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(10),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(10) + 1,
    },
  },
  listItemText: {
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
}));

export default function NavigationDrawer(props) {
  const classes = useStyles();
  const { navigation, open } = props;

  const IsActive = (route) => {
    const match = useRouteMatch(route);
    if (!match) return false;
    return true;
  };

  return (
    <Drawer
      variant="permanent"
      className={`${open ? classes.drawerOpen : classes.drawerClose}`}
      classes={{
        paper: `${open ? classes.drawerOpen : classes.drawerClose} ${
          classes.drawerPaper
        }`,
      }}
    >
      <ProfileMenu open={open} />
      <Divider variant="middle" />
      <Box component="nav" className={classes.navContainer}>
        <List key={navigation.header}>
          {open ? (
            <div className={classes.navHeader}>{navigation.header}</div>
          ) : (
            <div className={classes.CloseNavHeader}>{navigation.header[0]}</div>
          )}
          {navigation.links.map((l) => (
            <ListItem
              className={classes.listItem}
              key={l.text}
              button
              alignItems="center"
              to={l.route}
              component={NavLink}
              activeClassName={classes.activeNav}
            >
              <ListItemIcon className={classes.navItem}>
                {l.icon({
                  className: `${
                    IsActive(`${l.route}`) ? classes.activeNav : ""
                  }`,
                })}
              </ListItemIcon>
              <ListItemText className={classes.listItemText} primary={l.text} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
}
